<template lang='pug'>
  b-modal(
    :visible="show",
    no-close-on-backdrop)
    template(#modal-header)
      span.title {{$t('add_application')}}
    b-container(fluid)
      b-card.w-100.mb-3(no-body)
        b-list-group(flush)
          b-list-group-item
            b-row
              b-col.d-flex.align-items-center(cols="12" sm="3") {{$t('package_id')}}
              b-col(cols="12" sm="9") {{appInfo.package_id}}
      b-card.w-100.mb-3(no-body)
        b-list-group(flush)
          b-list-group-item
            b-row
              b-col.d-flex.align-items-center(cols="12" sm="3") {{$t('application')}} {{$t('name')}}
              b-col(cols="12" sm="9")
                template(v-if="appNameFlag === 1")
                  b-form-input(size='sm' :placeholder="$t('app_name_placeholder')" v-model='appInfo.temp_app_name' @input="onAppNameInput")
                template(v-else)
                  | {{appInfo.app_name}}
      b-card.w-100.mb-3(no-body)
        b-list-group(flush)
          b-list-group-item
            b-row
            b-row
              b-col.d-flex.align-items-center(cols="12" sm="3") {{$t('version')}}
              b-col(cols="12" sm="9") {{appInfo.app_version}}
      b-card.w-100.mb-3(no-body)
        b-list-group(flush)
          b-list-group-item
            b-row
              b-col.d-flex.align-items-center(cols="3") {{$t('file')}}
              b-col
                b-row
                  b-col.mb-2(cols="12" sm="9")
                    b-form-file.upload-input(v-model='file' :state='Boolean(file)' size="sm" :placeholder="$t('select_file')" :drop-placeholder="$t('drop_file')")
                  b-col.mb-2(cols="12" sm="3")
                    template(v-if='isUploading')
                      b-button(variant='primary' size="sm" class="w-100" disabled)
                        b-spinner(small)
                        | &nbsp
                        | &nbsp
                        span {{ $t('uploading') }}
                    template(v-else)
                      b-btn(@click='uploadFile' variant='primary' size="sm" class="w-100") {{$t('upload')}}
                b-row
                  b-col
                    b-row.pl-3.mt-2
                      label.d-flex
                        b-form-checkbox(v-model="run_after_installation")
                        span {{$t('run_after_installation')}}
    template(#modal-footer)
      b-btn(
        :disabled="isSubmitting || appInfo.package_id === '' || (appInfo.temp_app_name === undefined && appInfo.app_name === '')"
        size="sm",
        variant="primary",
        @click="handleAdd"
      ) {{$t('add')}}
      b-btn(size="sm", @click="close") {{$t('cancel')}}
</template>

<script>
import { ApplicationsAPI } from '@/api'

export default {
  name: 'DialogApplicationAdd',
  props: {
    show: Boolean,
    pk: Number,
  },
  data() {
    return {
      file: null,
      appInfo: {
        package_id: '',
        app_name: '',
        temp_app_name: '',
        db_app_name: '',
        app_version: '',
        version_code: '',
        file_name: '',
      },
      run_after_installation: false,
      appNameFlag: 0,
      isUploading: false,
      isSubmitting: false,
    }
  },
  watch: {
    'appInfo.app_name': {
      handler(newVal) {
        if (newVal === 'Unknown') {
          this.appNameFlag = 1
          // 감시 일시 해제
          this.$nextTick(() => {
            this.appInfo.app_name = ''
          })
        } else if (newVal === '') {
          // 초기값이 빈 문자열일 때는 플래그를 변경하지 않습니다.
        } else {
          this.appNameFlag = 0
        }
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.file = null
      this.appNameFlag = 0
      this.appInfo = {
        package_id: '',
        app_name: '',
        temp_app_name: '',
        db_app_name: '',
        app_version: '',
        version_code: '',
        file_name: '',
      }
      this.run_after_installation = false
      this.isUploading = false
      this.isSubmitting = false
      this.$emit('close')
    },
    async uploadFile() {
      if (!this.file) {
        alert(this.$t('select_file'))
        return
      }
      
      this.isUploading = true
      const chunkSize = 5 * 1024 * 1024
      const totalChunks = Math.ceil(this.file.size / chunkSize)
      
      for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
        const start = chunkIndex * chunkSize
        const end = Math.min(start + chunkSize, this.file.size)
        const chunk = this.file.slice(start, end)
        
        const formData = new FormData()
        formData.append('file', chunk)
        formData.append('chunkIndex', chunkIndex)
        formData.append('totalChunks', totalChunks)
        formData.append('fileName', this.file.name)
        
        try {
          const res = await ApplicationsAPI.post('upload', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          
          if (res.data.meta !== null) {
            this.appInfo = res.data.objects
          } else if (res.data.objects && res.data.objects.error) {
            throw new Error(res.data.objects.error)
          }
        } catch (error) {
          console.error(this.$t('application_upload_error'), error)
          if (error.message === '유효하지 않은 APK 파일입니다.') {
            this.$awn.warning(error.message)
          } else {
            this.$awn.warning(this.$t('application_upload_error'))
          }
          return
        }
      }
      this.isUploading = false
      this.$awn.success(this.$t('application_upload_success'))
    },
    async handleAdd() {
      if (this.appNameFlag === 1) { // 추가된 조건
        this.appInfo.app_name = this.appInfo.temp_app_name
        this.appNameFlag = 0
      }
      
      if (this.isSubmitting) {
        return
      }
      
      this.isSubmitting = true
      
      let params = {
        package_id: this.appInfo.package_id,
        file_name: this.appInfo.file_name,
        app_name: this.appInfo.app_name,
        db_app_name: this.appInfo.db_app_name,
        app_version: this.appInfo.app_version,
        version_code: this.appInfo.version_code,
        run_after_installation: this.run_after_installation,
      }
      
      try {
        const res = await ApplicationsAPI.post('', params)
        if (res.data.objects && res.data.objects.error === '이미 존재하는 애플리케이션입니다.') {
          throw new Error(this.$t('application_exist'))
        } else {
          this.$awn.success(this.$t('application_add_success'))
          this.close()
        }
      } catch (error) {
        console.error(this.$t('application_upload_error'), error)
        this.$awn.warning(error.message)
        this.close()
      } finally {
        this.isSubmitting = false
      }
    },
    onAppNameInput(value) {
      this.appInfo.temp_app_name = value
    },
  },
}
</script>

<style scoped lang="scss">
.title {
  font-size: 20px;
  font-weight: 500;
  color: #f0f0f0;
  line-height: 100%;
  letter-spacing: -.5px;
}

::v-deep .modal-dialog {
  max-width: 800px;
}
</style>